<template>

  <div class="columns is-mobile">
    <div class="column dashboard__menu">
      <div class="sidebar sidebar--static">
        <div class="inner">
          <ul class="sidebar-menu">
            <li title="Quản lý phòng họp">
              <router-link
                :to="'/ongoing-conference-list'"
                class="polycom-link is-active">
                <img src="@/assets/images/icons/icon-conf_control.png" alt="Quản lý phòng họp">
                <span class="is-block polycom-link-text">Quản lý phòng họp</span>
              </router-link>
            </li>
            <li title="Quản lý người dùng">
              <router-link
                :to="'/user-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-address.png" alt="Quản lý người dùng">
                <span class="is-block polycom-link-text">Quản lý người dùng</span>
              </router-link>
            </li>
            <li title="Tạo lịch họp">
              <router-link
                :to="'/calendar'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-schedule.png" alt="Tạo lịch họp">
                <span class="is-block polycom-link-text">Tạo lịch họp</span>
              </router-link>
            </li>
            <li title="Lọc người tham gia phòng họp">
              <router-link
                :to="'/passcode-room-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-reservation.png" alt="Lọc người tham gia phòng họp">
                <span class="is-block polycom-link-text">Lọc người tham gia phòng họp</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div class="column content-management">
      <div class="roomList">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/index">Trang chủ</router-link></li>
              <li class="is-active"><a>Các cuộc họp đang diễn ra</a></li>
            </ul>
          </nav>
        </div>
        <div v-if="roomList && Object.keys(roomList).length">
          <div class="content-tab">
            <div class="card-heading-tab">
              <span class="card-icon-tab">
                <img src="@/assets/images/icons/icon-meeting.png">
              </span>
              <span class="card-text">Các cuộc họp đang diễn ra</span>
              <span @click="updateConferenceList" class="button-reload">
                <b-icon icon="redo"/>
              </span>
            </div>
            <table class="table is-fullwidth userList__table">
              <tbody>
                <tr
                  v-for="(conference, index) in conferenceIdentityList"
                  :key="conference.conferenceId"
                  :class="{'is-odd': index%2 !== 0}">
                  <td class="has-text-left table-room-id">{{conference.conferenceId|shortenConferenceId}}</td>
                  <td class="has-text-left table-room-id">{{conference.roomId}}</td>
                  <td class="has-text-left">{{conference.displayName}}</td>
                  <td class="has-text-right">
                    <router-link :to="{path: '/ongoing-conference', query: {
                      roomID_MCU: conference.roomID_MCU,
                      confId: conference.conferenceId,
                      id: conference.id
                      }}" class="link" exact>Quản trị cuộc họp
                      <span class="icon-conf-setting">
                        <img src="@/assets/images/icons/icon-conf_setting.png">
                      </span>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="content-tab">
            <div class="card-heading-tab"><span class="card-icon-tab"><img src="@/assets/images/icons/icon-meeting.png"></span><span class="card-text">Danh sách các phòng họp</span></div>
            <table class="table is-fullwidth userList__table">
              <tbody>
                <tr
                  v-for="(room, index) in roomList"
                  :key="room.roomIdentifier"
                  :class="{'is-odd': index%2 !== 0}">
                  <td class="has-text-left table-room-id">{{room.roomIdentifier}}</td>
                  <td class="has-text-right">
                    <div class="columns">
                      <div class="column has-text-center">
                        <span class="roomList__passcode">{{room.passCode|| 'Không có'}}</span>
                        <b-button
                          type="is-danger"
                          @click="openResetPassCodeModal(room)"
                          class="roomList__btn-new"
                          v-if="room.passCode"
                        >Xoá</b-button>
                        <b-button
                          type="is-info"
                          @click="openPassCodeModal(room)"
                          class="roomList__btn-new"
                        >Thay đổi</b-button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>

        <div v-else>
          <p class="title is-6" style="text-align: center">
            <img class="loading" src="@/assets/images/icons/loading.gif" alt="Loaing">
          </p>
        </div>

        <b-modal :active.sync="isOpenPassCodeModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head">
              <p class="modal-card-title">Tạo mật khẩu phòng họp {{selectedRoom&&selectedRoom.id}}</p>
              <button
                aria-label="close"
                class="delete"
                @click="isOpenPassCodeModal=false"/>
            </header>
            <form @submit.prevent="createPasscode" data-vv-scope="passCodeForm">
            <div class="content-layout__inner">
              <div class="form-user">
                <b-field
                  :type="{'is-danger': errors.has('passCodeForm.new-pass-code')}"
                  :message="errors.first('passCodeForm.new-pass-code')"
                  label="Mật khẩu" custom-class="has-text-weight-normal">
                  <b-input
                    v-model="newPasscode"
                    type="number"
                    name="new-pass-code"
                    size="is-medium"
                    v-validate="'required'"
                    data-vv-as="Mật khẩu"
                    ref="newPassCode"/>
                </b-field>
              </div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isOpenPassCodeModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-info" native-type="submit">Thay đổi</b-button>
              </div>
            </div>
            </form>
          </div>
        </b-modal>
        <b-modal :active.sync="isResetPassCodeModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head">
              <p class="modal-card-title">Xoá mật khẩu phòng họp {{selectedRoom&&selectedRoom.id}}</p>
              <button
                aria-label="close"
                class="delete"
                @click="isResetPassCodeModal=false"/>
            </header>
            <div class="content-layout__inner">
              <div>Xin xác nhận xoá mật khẩu phòng họp?</div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isResetPassCodeModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-danger" @click="deletePasscode">Xoá</b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>


</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isOpenPassCodeModal: false,
      newPasscode: 0,
      selectedRoom: null,
      selectedParticipant: null,
      isOpenDialModal: false,
      dialOut: {
        name: "",
        text: ""
      },
      selectedLayout: "Chọn Layout hiển thị",
      isLoadButtonView: false,
      isLoadButtonStart: false,
      roomIds: [],
      isResetPassCodeModal: false
    };
  },
  created() {
    this.$store.dispatch("room/getRooms", this.$store.state.auth.username).then(() => {
      this.roomIds = this.roomList.map(room => room.roomIdentifier)
      this.getConferenceIdList({roomIds: this.roomIds})
    });
  },
  methods: {
    ...mapActions("room", ["getConferenceIdList"]),
    // manage room
    openPassCodeModal(room) {
      const newRoom = { ...room };
      this.selectedRoom = {
        id: newRoom.roomIdentifier,
        entityTag: newRoom.entityTag
      };
      this.isOpenPassCodeModal = true;
      this.$nextTick(() => {
        this.$refs.newPassCode.$el.querySelector('input').focus()
      })
    },
    createPasscode() {
      this.$validator.validateAll('passCodeForm').then((result) => {
        if(result) {
          const username = this.$store.state.auth.username;
          if (this.selectedRoom) {
            this.$store
              .dispatch("room/newPasscode", {
                username,
                room: this.selectedRoom,
                passCode: this.newPasscode
              })
              .then(res => {
                if (res.data.status) {
                  this.$toast.open({
                    message: "Thay đổi mật khẩu phòng thành công",
                    type: "is-info"
                  });
                } else {
                  this.$toast.open({
                    message: "Thay đổi mật khẩu phòng không thành công",
                    type: "is-danger"
                  });
                }
              });
          }
          this.newPasscode = 0;
          this.selectedRoom = null;
          this.$nextTick(() => {
            this.$validator.reset()
            this.isOpenPassCodeModal = false;
          })
        }
      })
    },
    deletePasscode() {
      const username = this.$store.state.auth.username;
      const newRoom = {
        id: this.selectedRoom.id,
        entityTag: this.selectedRoom.entityTag
      };
      if (newRoom) {
        this.$store
          .dispatch("room/deletePasscode", {
            username,
            room: newRoom,
            passCode: ""
          })
          .then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Xoá mật khẩu phòng thành công!",
                type: "is-info"
              });
            } else {
              this.$toast.open({
                message: "Xoá mật khẩu phòng không thành công!",
                type: "is-danger"
              });
            }
          });
        this.selectedRoom = null;
        this.isResetPassCodeModal = false;
      }
    },
    updateConferenceList() {
      if(this.roomIds.length) {
        this.getConferenceIdList({roomIds: this.roomIds})
      }
    },

    // manage joint participant, conference
    getConferenceId(room) {
      // create virtual conference
      const newRoom = { ...room };
      
      this.selectedRoom = {
        id: newRoom.roomIdentifier,
        entityTag: newRoom.entityTag
      };
      

      this.isLoadButtonView = true;

      this.$store
        .dispatch("room/getConferenceId", newRoom.roomIdentifier)
        .finally(() => (this.isLoadButtonView = false));

    },
    startRoom(room) {
      const { roomIdentifier } = room;
      this.isLoadButtonStart = true;
      this.$store
        .dispatch("room/startConference", roomIdentifier)
        .then(res => {
          if (res.data.status == true) {
            this.$toast.open({
              message: "Đã khởi động!!",
              type: "is-info"
            });
          } else if (res.data.status == 409) {
            this.$toast.open({
              message: "Phòng họp đã được khởi động!",
              type: "is-info"
            });
            this.getConferenceId(room);
          } else {
            this.$toast.open({
              message: "Lỗi máy chủ",
              type: "is-danger"
            });
          }
        })
        .finally(() => (this.isLoadButtonStart = false));
    },
    openResetPassCodeModal(room) {
      this.isResetPassCodeModal = true;
      this.selectedRoom = {
        id: room.roomIdentifier,
        entityTag: room.entityTag
      };
    }
  },
  computed: {
    ...mapState("room", ["roomList", "conferenceIdentityList"]),
  },
  filters: {
    shortenConferenceId(value) {
      return `Cuộc họp ${value.split('-')[0]+'...'}`
    }
  }
};
</script>

<style lang="scss" scope>
@import "@/assets/scss/partials/_colors.scss";
.roomList {
  padding-left: 0;
  padding-right: 0;

  .roomList__btn-new {
    vertical-align: middle;
    margin-left: 10px;
  }

  &__passcode {
    display: inline-block;
    vertical-align: middle;
  }
  &__heading {
    width: 100px;
  }
}
.link {
  color: #666;
}
.icon-conf-setting {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  margin-left: 5px;
}
</style>
